import { FC } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { WordDictionaryInfo } from '../../types/wordbook';
import { formatKstDateTime } from '../../utils/dateTime';

interface Props {
    info: WordDictionaryInfo;
}

const Row: FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
    <Box display="flex" gap={1} alignItems="baseline">
        <Typography variant="caption" color="text.secondary" sx={{ minWidth: 80 }}>
            {label}
        </Typography>
        <Box flex={1}>{children}</Box>
    </Box>
);

export const DictionaryInfoPanel: FC<Props> = ({ info }) => {
    return (
        <Stack spacing={0.75}>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Chip label={`dict #${info.id}`} size="small" color="primary" />
                <Typography variant="subtitle2" fontWeight={600}>
                    {info.word}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {info.languageCode}
                </Typography>
                {info.pos && <Chip label={info.pos} size="small" variant="outlined" />}
                {info.phonetic && (
                    <Typography variant="caption" sx={{ fontFamily: 'monospace' }} color="text.secondary">
                        [{info.phonetic}]
                    </Typography>
                )}
            </Stack>
            {info.translation && (
                <Row label="번역">
                    <Typography variant="body2">
                        {info.translation}
                        {info.translationLang && (
                            <Typography component="span" variant="caption" color="text.secondary" ml={0.5}>
                                ({info.translationLang})
                            </Typography>
                        )}
                    </Typography>
                </Row>
            )}
            {info.difficultyScore !== null && info.difficultyScore !== undefined && (
                <Row label="난이도">
                    <Typography variant="body2">{info.difficultyScore.toFixed(1)}</Typography>
                </Row>
            )}
            {info.aiProvider && (
                <Row label="AI 제공자">
                    <Typography variant="body2">{info.aiProvider}</Typography>
                </Row>
            )}
            {info.sourceType && (
                <Row label="출처">
                    <Typography variant="body2">{info.sourceType}</Typography>
                </Row>
            )}
            <Row label="히트">
                <Typography variant="body2">{info.hitCount}</Typography>
            </Row>
            <Row label="수정일">
                <Typography variant="body2">{formatKstDateTime(info.updatedAt)}</Typography>
            </Row>
        </Stack>
    );
};
